import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignDto } from "../../../models/campaign/dto/campaign.dto";

export const GET_CAMPAIGN_QUERY_KEY = (id: string) => ['campaigns', id];

export const useGetCampaign = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CAMPAIGN_QUERY_KEY(id),
        queryFn: () => client.fetchApi<CampaignDto, {}>({
            endpoint: `campaigns/admin/detail/${id}`,
            method: 'GET'
        }),
        staleTime: 30_000,
        enabled: !!id,
    });
};
